<template>
  <div class="teacher_data">
    <!-- Start Main Loader -->

    <!-- End Main Loader -->
    <div class="personal_data_wrapper fadeIn" v-if="userInfo">
      <div class="order-details-page mb-5">
        <div class="row py-2 mx-1 justify-content-center align-items-center">
          <div class="col-12">
            <div class="details border-right-0">
              <div class="row">
                <div class="col-sm-6 pt-0" v-if="userInfo.full_name">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.name") }}
                        </h5>
                        <p>{{ userInfo.full_name }}</p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-user"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0" v-if="userInfo.orders_count">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.orders") }}
                        </h5>
                        <p>{{ userInfo.orders_count }}</p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-bars"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0" v-if="userInfo.my_profits">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.profit") }}
                        </h5>
                        <p>{{ userInfo.my_profits }}</p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-wallet"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-sm-12 pt-0"
                  v-if="userInfo.clients && userInfo.clients.length > 0"
                >
                  <!-- Start Main Section -->
                  <main>
                    <v-data-table
                      class="thumb strip"
                      :headers="headers"
                      :items="userInfo.clients"
                      :loading="loading"
                      :loading-text="$t('table.loadingData')"
                      item-key="id"
                      :items-per-page="60"
                      hide-default-footer
                    >
                      <!-- ================== You Can use any slots you want ================== -->
                      <!-- ====== Select row field ====== -->
                      <!-- Image -->
                      <template v-slot:[`item.avatar`]="{ item }">
                        <img
                          @click="show_model_1"
                          class="image"
                          :src="item.avatar"
                        />
                      </template>

                      <template v-slot:[`item.index`]="{ index }">
                        {{ index + 1 }}
                      </template>

                      <!-- Select no data State -->
                      <template v-slot:no-data>
                        {{ $t("table.noData") }}
                      </template>
                      <template v-slot:[`item.is_ban`]="{ item }">
                        <v-btn
                          @click="toggleStatusModel(item)"
                          :color="item.is_ban ? 'error' : 'success'"
                          >{{ item.is_ban ? "محظور" : "غير محظور" }}</v-btn
                        >
                      </template>
                      <template v-slot:[`item.email`]="{ item }">
                        <span>{{ item.email || "لا يوجد" }}</span>
                      </template>
                      <!-- IsActive -->
                      <!-- <template v-slot:[`item.is_active`]="{ item }">
            <span class="status" :class="item.is_active ? 'paid' : 'unpaid'">
              {{ item.is_active ? "مفعل" : "معطل" }}
            </span>
          </template> -->
                      <template v-slot:[`item.full_name`]="{ item }">
                        <span v-if="item.full_name">{{ item.full_name }}</span>
                        <span v-else>لا يوجد</span>
                      </template>
                      <!-- <template v-slot:[`item.phone`]="{ item }">
            <span v-if="!item.phone || item.phone == ''">لا يوجد</span>
            <span>{{ item.phone_code + item.phone }}</span>
          </template> -->
                      <!-- Select actions-->
                      <template v-slot:[`item.actions`]="{ item }">
                        <div class="_actions">
                          <v-icon class="show" small @click="showItem(item)">
                            fal fa-eye
                          </v-icon>
                        </div>
                      </template>

                      <!-- ======================== Start Top Section ======================== -->
                      <!-- ======================== End Top Section ======================== -->
                    </v-data-table>
                  </main>
                  <!-- End Main Section -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  data() {
    return {
      // ========== Loading
      loading: false,
      userInfo: null,
      model_1: {
        show_model: false,
        model_img_src: "",
      },
    };
  },
  computed: {
    headers() {
      if (this.lang != "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "الصورة",
            align: "center",
            value: "avatar",
            sortable: false,
          },
          {
            text: "الاسم",
            value: "full_name",
            align: "center",
          },
          {
            text: "العائد",
            value: "profit",
            align: "center",
          },
          {
            text: "الكود",
            value: "base_referral_code",
            align: "center",
          },
          {
            text: "التحكم",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "image",
            align: "center",
            value: "image",
            sortable: false,
          },
          { text: "Name", value: "fullname", align: "center" },
          { text: "Followers", value: "followers_count", align: "center" },
          { text: "Following", value: "followings_count", align: "center" },
          {
            text: "Active",
            value: "is_active",
            align: "center",
          },
          {
            text: "Permission",
            value: "role",
            align: "center",
          },
          {
            text: "control",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
  },

  methods: {
    getData() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: `referral/${this.id}`,
      })
        .then((res) => {
          this.userInfo = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.data.loading = false;
        });
    },
    showItem(item) {
      if (item.user_type == "client") {
        this.$router.push({ path: "/client/show/" + item.id });
      } else if (item.user_type == "driver") {
        this.$router.push({ path: "/driver/show/" + item.id });
      }
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
  },
  // ============== Get User Location

  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.border-right-0 {
  border-right-width: 0 !important;
}
.icon {
  padding: 7px 10px;
}
.teacher_data .item .info {
  background-color: white !important;
}
.ban_reason {
  border: 1px solid var(--mainColor-2);
  width: 100%;
  border-radius: 10px;
  height: 7rem;
  outline: none;
  // &:focus {
  //   border: 1px solid var(--mainColor-2);
  // }
  &::placeholder {
    color: var(--mainColor-2);
  }
}
</style>
